function IconCard() {
    this.icons = null;
    this.generatedIcons = [];    
}
if (typeof exports !== 'undefined') {
    module.exports = IconCard;
}